<template>
	<div class="error center middle-column">
		<h3>页面错误,重新登录</h3>
		<button @click="returnToLogin">返回</button>
	</div>
	
</template>

<script>
	export default {
		name:'error',
		methods:{
			returnToLogin(){
				window.location.href='https://www.mwhs.cn'
			}
		}
	}
</script>

<style>
	html,body,.error{
		height: 100vh;
		width: 100vw;
	}
</style>
